import React, { useState } from "react"
import ProductItem from "../product/item"
import { Link } from "gatsby"
import { ReactComponent as Arrow } from "@svgs/arrow.svg"
import Section from "@components/section"
import { isVisibleIn } from "@src/utils/region"
import CompareAtCrates from "@src/components/compare-at-modal"

const CrossSells = ({
  title = `You might also like`,
  intro = `Upgrade your dog’s comfort with our stylish and functional essentials.`,
  atc = {
    text: "View all products",
    internalLink: "/collections",
  },
  products = []
}) => {
  const [showCompareModal, setShowCompareModal] = useState(false);
  let relatedProducts = [];

  if (products && products.length > 0) {
    relatedProducts = products.reduce((accumulator, product) => {
      if (isVisibleIn(product.visibilityRegions) && product.showInProductListing && product.enabled) {
        accumulator.push(product);
      }
      return accumulator;
    }, []);
  }

  return (
    <Section settings={{ classname: "overflow-hidden" }} containerClassname="!pr-0 xl:!pr-[60px]">
      <div className="flex flex-row overflow-x-auto overflow-y-hidden sm:scrolling-touch max-md:pb-2.5 w-full bg-blush" tabIndex={0} aria-label={title}>
        <div className={`h-full min-w-[280px] md:min-w-[315px] md:w-1/4 md:shrink-0 bg-sage p-5 sm:p-10 rounded-xl`}>
          <div className="flex flex-col h-full">
            <h2 className="text-4xl">{title}</h2>
            <div className="flex mt-auto flex-col gap-10">
              <p className="text-base leading-5">{intro}</p>
              <Link
                to={atc.internalLink}
                className="btn bg-white text-near-black border-black hover:border-black hover:bg-transparent w-full flex items-center"
              >
                {atc.text}
                <Arrow className="ml-2 arrow fill-black" />
              </Link>
            </div>
          </div>
        </div>
        {relatedProducts.length > 0 &&
          <>
            <div
              className="flex flex-no-wrap md:overflow-x-auto scrolling-touch pl-3.5"
            >
              {relatedProducts.map((product, index) => {
                return (
                  <ProductItem
                    className="min-w-[280px] md:min-w-[315px] max-w-[315px] w-full"
                    key={index}
                    index={index}
                    label="Select Options"
                    product={product}
                    productInfos
                    twoDescLine
                    buttonTheme={{ desktop: 'btn-transparent', mobile: 'btn-secondary' }}
                    imageHeight="h-fit"
                    showSeeMore
                    showPlusSign={true}
                    setShowCompareModal={setShowCompareModal}
                  />
                )
              })}
            </div>
          </>
        }
      </div>
      {showCompareModal && (
        <CompareAtCrates
          showCompareModal={showCompareModal}
          setShowCompareModal={setShowCompareModal}
        />
      )}
    </Section>
  )
}



export default CrossSells
